<div class="simulator-screen">
  <p-menubar [model]="menuItems">
    <div style="font-size: 16px; line-height: 26px; margin-right: 8px; display: flex">

      <a style="margin-right: 0.5em; text-decoration: none" href="/docs" target="_blank">
        <button
          pButton
          pRipple
          type="button"
          label="Docs"
          class="p-button-raised p-button-help"
        ></button>
      </a>

      <button
        pButton
        pRipple
        type="button"
        label="Toggle right pane"
        class="p-button-raised"
        (click)="onRightPanelToggle()"
        [ngClass]="{'p-button-outlined': !config.rightBarVisible}"
      ></button>

    </div>
  </p-menubar>
  <a #fileDownload download="source.asm" style="display: none;"></a>
  <input #fileInput (change)="onFileChange($event)" accept=".asm" style="display: none;" type="file">
  <div class="main-container">
    <div [ngClass]="{'with-center-pane': showCentralPane}" class="left-pane">
      <div style="height: 100%; width: 100%; position: relative">
        <div class="code-editor" #codeEditor></div>
        <div style="position: absolute;bottom: 0;right: 0;left: 0;padding: 0 20px;z-index: 10;">
          <p-messages style="margin: auto"></p-messages>
        </div>
      </div>
    </div>
    <div class="center-pane">
      <app-registers-view (onRegisterClick)="toggleDisplayRegister($event)"></app-registers-view>
      <div class="memory-view-container">
        <app-memory-view (whenMemoryCellClick)="memoryCellClick($event)" [displayA]="displayA" [displayB]="displayB"
                         [displayC]="displayC"
                         [displayD]="displayD" [ramContent]="ramContent"></app-memory-view>
      </div>
    </div>
    <div [ngClass]="{'collapsed': config.rightBarVisible}" class="right-pane">

      <div style="min-height: 0; flex-grow: 1">
        <p-panel header="Input / Output Devices" styleClass="registers-panel">
          <div
            style="text-align:center; padding-top: 10px; padding-bottom: 10px">
            <app-visual-display></app-visual-display>
            <app-textual-display></app-textual-display>
          </div>
          <div style="text-align:center; padding-top: 10px">
            <app-keypad></app-keypad>
          </div>
        </p-panel>
      </div>
      <div style="min-height: 0; flex-grow: 1">
        <app-ioregisters-view></app-ioregisters-view>
      </div>
    </div>
  </div>
</div>
